import React, { useEffect } from "react";
import "./organization-router.scss";

import { useMatch, Outlet } from "react-router-dom";
import { useDispatch } from "react-redux";
import {selectCurrentUser, setNav} from "../reducers/appSlice";
import {
  selectOrganization,
  getOrganizationFacilities,
  selectCurrentOrganization,
} from "../reducers/organizationSlice";
import { useCallback } from "react";
import { GSButton } from "golfstatus_react_components";
import { faChevronLeft } from "@fortawesome/free-solid-svg-icons";
import { useSelector } from "react-redux";
import { isGolfStatus } from "../helpers/Access";
import GolfstatusOrganizationTOS from "./golfstatus-organization-tos";

const OrganizationRouter = () => {
  const dispatch = useDispatch();
  const match = useMatch("/:id/*");
  const currentOrg = useSelector(selectCurrentOrganization);
  const currentUser = useSelector(selectCurrentUser);
  const loadData = useCallback(() => {
    dispatch(selectOrganization(match?.params?.id));
    dispatch(getOrganizationFacilities(match?.params?.id));
  }, [match?.params?.id, dispatch]);
  useEffect(() => {
    loadData();
  }, [loadData]);
  const permitted = () => {
    return (
      currentOrg?.tosAcceptedAt || isGolfStatus(currentUser)
    );
  };
  useEffect(() => {
    dispatch(
      setNav([
        {
          id: 1,
          label: (
            <GSButton
              type="secondary"
              title="my organizations"
              buttonIcon={faChevronLeft}
            />
          ),
          url: `/`,
          isSelectable: true,
        },
        { id: 1, label: currentOrg.name, isSelectable: false, type: "bold" },
        {
          id: 1,
          label: "Overview",
          url: `/${match?.params?.id}`,
          isSelectable: true,
        },
        {
          id: 1,
          label: "Users & Permissions",
          url: `/${match?.params?.id}/permissions`,
          isSelectable: true,
        },
        {
          id: 1,
          label: "Discounts",
          url: `/${match?.params?.id}/discounts`,
          isSelectable: true,
        },
        {
          id: 1,
          label: "Access Lists",
          url: `/${match?.params?.id}/access`,
          isSelectable: true,
        },
        {
          id: 1,
          label: "Settings & Preferences",
          url: `/${match?.params?.id}/settings`,
          isSelectable: true,
        },
      ])
    );
  }, [currentOrg, dispatch, match?.params?.id]);
  return permitted() ? <Outlet /> : <GolfstatusOrganizationTOS />;
};

export default OrganizationRouter;
